import React from 'react'
import './SucessmsgQB/SucessMsgQb.css'
import Loader from '../../Helper/Loader'

export default function ChangeNamePopup({
    setOpenRenameQuestionBankNamePopup,
    questionBankRenameData,
    setQuestionBankRenameData,
    handleRenameQuestionBankName,
    isProcessLoading
}) {
    return (
        <div className='Conteiner_sucessMsg_QB' style={{ zIndex: 999 }}>
            <div className='subConteiner_sucessMsg_QB p-4'>
                {isProcessLoading ? <Loader /> :
                    <>
                        <div className='d-flex justify-content-center mt-3 flex-column'>
                            <div className="hw_question_no mb-3">New Question Bank Name</div>
                            <input
                                type='text'
                                maxLength={250}
                                className="hw_question_box"
                                placeholder="Question bank Name"
                                value={questionBankRenameData.questionBankName}
                                onChange={(e) => setQuestionBankRenameData((prev) => {
                                    return {
                                        ...prev,
                                        questionBankName: e.target.value
                                    }
                                })}

                            />
                        </div>
                        <div className='d-flex justify-content-center mt-3'>
                            <button className='sucess_okayBtn_Qb me-3' onClick={() => setOpenRenameQuestionBankNamePopup(false)}>Cancel</button>
                            <button className='sucess_okayBtn_Qb' onClick={() => { handleRenameQuestionBankName(questionBankRenameData.questionBankId) }}>Okay</button>
                        </div>
                    </>
                }
            </div>
        </div>
    )
}
